import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import { typesToFilter } from '#component/device/dashboard/helper';
import { StyledTextField, StyledValueContainer, StyledPlaceholder, SelectContainer } from './style';

const Option = props => {
  const { disabledBy } = props.data;
  return (
    <MenuItem
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        whiteSpace: 'normal'
      }}
      disabled={Boolean(disabledBy)}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
};

const inputComponent = React.forwardRef(
  (props, ref) => <div ref={ref} {...props} />
);

const Control = props => (
  <StyledTextField
    InputProps={{
      inputComponent,
      inputProps: {
        children: props.children,
        ...props.innerProps
      }
    }}
    {...props.selectProps.textFieldProps}
  />
);

const IndicatorSeparator = ({ innerProps }) =>
  <span {...innerProps} />;

const CustomValueContainer = props => (
  <StyledValueContainer>
    {props.children}
  </StyledValueContainer>
);

const components = {
  Option,
  Control,
  IndicatorSeparator,
  ValueContainer: CustomValueContainer
};

const selectStyles = {
  input: base => ({
    ...base,
    '& input': {
      font: 'inherit'
    }
  }),
  indicatorsContainer: base => ({
    ...base,
    cursor: 'pointer'
  }),
  menu: base => ({
    ...base,
    zIndex: 1300
  }),
  menuList: base => ({
    ...base,
    '&::-webkit-scrollbar-track': {
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 10,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar': {
      width: 8,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
      backgroundColor: '#a0a0a0'
    }
  })
};

const CustomSelect = props => {
  const { meta, projectId, addMode, openedFromCreateForm, setDeviceType, data } = props;
  const dispatch = useDispatch();
  const devicesTypes = useMemo(() => typesToFilter(meta?.device, true), [meta]);
  const [selectValue, setSelectValue] = useState(devicesTypes[0]);

  const handleSetFilter = d => {
    dispatch(setDeviceType(d, projectId, addMode, openedFromCreateForm, data));
  };

  const handleChange = value => {
    setSelectValue(value);
    handleSetFilter(value);
  };

  return (
    <SelectContainer>
      <Select
        styles={selectStyles}
        placeholder={
          <StyledPlaceholder>Device type</StyledPlaceholder>
        }
        value={selectValue}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={false}
        components={components}
        options={devicesTypes}
        onChange={handleChange}
      />
    </SelectContainer>
  );
};

export default CustomSelect;
